import { render } from "./BaseError.vue?vue&type=template&id=7d2525cb&ts=true"
import script from "./BaseError.vue?vue&type=script&lang=ts"
export * from "./BaseError.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__